import {AnalyticsBrowser} from '@segment/analytics-next';
import {parseQuery} from '../utils';
import {ANALYTICS_EVENTS} from './constants';
import {IS_PROD_ENV} from '../constants';
import {IdentifyOptions, TrackProperties} from './types';

const ANALYTICS_PREFIX = 'tr_';

class AnalyticsService {
    private isEventsTracked: boolean = true;

    private analytics: AnalyticsBrowser = new AnalyticsBrowser();

    load = (writeKey: string) => this.analytics.load({writeKey});

    identify = (userId: number | string | undefined, options?: IdentifyOptions) => {
        const {isEventsTracked = true} = options ?? {};
        this.isEventsTracked = !IS_PROD_ENV || isEventsTracked;

        if (!this.isEventsTracked) {
            return;
        }

        this.analytics.identify(String(userId));
    };

    reset = () => {
        this.analytics.reset();
        this.isEventsTracked = true;
    };

    track = (eventName: string, properties = {}, callback?: Function | undefined) => {
        if (!this.isEventsTracked) {
            return;
        }

        const additionalProperties = Object
            .entries(parseQuery(window.location.search))
            .reduce((acc, [key, value]) => {
                return key.startsWith(ANALYTICS_PREFIX) ? {...acc, [key]: value} : acc;
            }, {});

        this.analytics.track(eventName, {...properties, ...additionalProperties}, callback);
    };
}

export default new AnalyticsService();
export type {TrackProperties};
export {ANALYTICS_EVENTS, ANALYTICS_PREFIX};
